<template>
  <!-- 客诉记录基础信息-组件 -->
  <el-descriptions title="客诉记录基础信息" :column="4" class="descriptions-content">
    <el-descriptions-item label="申诉人姓名">{{ data.name }}</el-descriptions-item>
    <el-descriptions-item label="联系方式">{{ data.phone }}</el-descriptions-item>
    <el-descriptions-item label="性格">{{ data.character }}</el-descriptions-item>
    <el-descriptions-item label="申诉方理解能力">{{ data.comprehension }}</el-descriptions-item>
    <el-descriptions-item label="申诉来源">{{ data.origin }}</el-descriptions-item>
    <el-descriptions-item label="申诉次数">{{ data.times || 0 }} 次</el-descriptions-item>
    <el-descriptions-item label="处理结果">{{ data.result }}</el-descriptions-item>
    <el-descriptions-item label="预约跟进时间">{{ data.followUpTime }}</el-descriptions-item>
    <el-descriptions-item label="申诉内容">
      <template v-if="data.appealOption">
        {{ appealOptionList[data.appealOption].label }}<span v-if="Number(data.appealOption) === 7">（{{ data.content }}）</span>
      </template>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: 'AppealsDescriptions',
  props: {
    // 客诉记录基础信息
    data: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      // 申诉内容类型
      appealOptionList: [
        {
          value: '0',
          label: '不同意拒互助结论'
        },
        {
          value: '1',
          label: '不同意爱心互助'
        },
        {
          value: '2',
          label: '不同意低度互助'
        },
        {
          value: '3',
          label: '对不足额有疑问'
        },
        {
          value: '4',
          label: '不接受调查结论'
        },
        {
          value: '5',
          label: '不接受缴费'
        },
        {
          value: '6',
          label: '服务态度'
        },
        {
          value: '7',
          label: '其他'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
